import React from 'react';
import './WhatsAppFloat.css';
import WhatsAppIcon from '../../assets/WhatsApp.webp';

const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5541998330446', '_blank');
  };

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <img src={WhatsAppIcon} alt="WhatsApp" className="whatsapp-icon" />
    </div>
  );
};

export default WhatsAppFloat;

